import { AlertCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter
} from '@/components/ui/dialog'
import { Alert, AlertDescription } from '@/components/ui/alert'

const SubmitModal = ({ closeModal, isOpen }) => (
  <Dialog
    open={isOpen}
    onOpenChange={(open) => !open && closeModal()}
  >
    <DialogContent>
      <DialogHeader>
        <DialogTitle className='font-heading text-2xl font-bold'>Submit lesson</DialogTitle>
      </DialogHeader>

      <p className='mt-3'>Would you like to submit this lesson?</p>

      <Alert>
        <AlertCircle className='h-4 w-4' />
        <AlertDescription>
          You won't be able to make changes again.
        </AlertDescription>
      </Alert>

      <DialogFooter className='flex flex-row justify-between items-center mt-6'>
        <Button
          variant='ghost'
          onClick={closeModal}
        >
          Cancel
        </Button>

        <Button
          disabled
        >
          Submit
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
)

export default SubmitModal
